import React from 'react';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import { connect } from 'react-redux';
import moment from 'moment';
import { Table, TableBody, TableCell, TableHead, TableRow, Chip, IconButton } from '@material-ui/core';
import { CommentOutlined, LockOpenOutlined } from '@material-ui/icons';
import GetAppIcon from '@material-ui/icons/GetApp';
import FormFlatContainer from '../forms/Elements/FormFlatContainer.jsx';
import KeyOutlinedIconCustom from '../CustomIcons/KeyOutlinedIconCustom.jsx';
import FileCheckIconCustom from '../CustomIcons/FileCheckIconCustom.jsx';
import { MKS_REQUEST_TYPES, MKS_REQUEST_STATUSES_PARAMETERS, BLUE } from '../../_config/consts';

@connect(state => ({
  mks: state.mks,
}))
class MksRequestDetailsView extends React.Component {

  renderRequestTypeDetails() {
    const { requestData } = this.props;
    const requestType = requestData.requestType;
    const data = requestData.data || {};

    if (requestType === MKS_REQUEST_TYPES.KEY_DUPLICATION) {
      const keysDuplicates = data.keysDuplicates ? JSON.parse(data.keysDuplicates) : [];
      
      return (
        <FormFlatContainer
          title="keyDuplicationItems"
          subtitle="keyDuplicationItemsSubtitle"
          icon={<KeyOutlinedIconCustom style={{ width: 22, color: '#3f3f3f' }} />}
          containerStyle={{ marginRight: 15, marginTop: 20 }}
        >
          {!_.isEmpty(keysDuplicates) ? (
            <Table size="small">
              <TableHead>
                <TableRow style={{ backgroundColor: '#f0f0f0' }}>
                  <TableCell><h5 style={{ fontWeight: 'bold', margin: 0 }}><Entity entity="mksKeys" /></h5></TableCell>
                  <TableCell><h5 style={{ fontWeight: 'bold', margin: 0 }}><Entity entity="designation" /></h5></TableCell>
                  <TableCell><h5 style={{ fontWeight: 'bold', margin: 0 }}><Entity entity="keyFunction" /></h5></TableCell>
                  <TableCell><h5 style={{ fontWeight: 'bold', margin: 0 }}><Entity entity="quantity" /></h5></TableCell>
                </TableRow>
              </TableHead>
              <TableBody style={{ backgroundColor: 'white' }}>
                {_.map(keysDuplicates, (item, index) => {
                  const key = item.key || {};
                  return (
                    <TableRow key={index}>
                      <TableCell><h5 style={{ margin: 0 }}>{key.externalId || key.id || '---'}</h5></TableCell>
                      <TableCell><h5 style={{ margin: 0 }}>{key.designation || '---'}</h5></TableCell>
                      <TableCell><h5 style={{ margin: 0 }}>{key.keyFunction || '---'}</h5></TableCell>
                      <TableCell><h5 style={{ margin: 0 }}>{item.quantity || '---'}</h5></TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          ) : (
            <div style={{ textAlign: 'center', padding: 20 }}>
              <h5 style={{ color: '#888' }}><Entity entity="noItemsFound" /></h5>
            </div>
          )}
        </FormFlatContainer>
      );
    }

    if (requestType === MKS_REQUEST_TYPES.CYLINDER_DUPLICATION) {
      const cylindersDuplicates = data.cylindersDuplicates ? JSON.parse(data.cylindersDuplicates) : [];
      
      return (
        <FormFlatContainer
          title="cylinderDuplicationItems"
          subtitle="cylinderDuplicationItemsSubtitle"
          icon={<LockOpenOutlined style={{ fontSize: 22, color: '#3f3f3f' }} />}
          containerStyle={{ marginRight: 15, marginTop: 20 }}
        >
          {!_.isEmpty(cylindersDuplicates) ? (
            <Table size="small">
              <TableHead>
                <TableRow style={{ backgroundColor: '#f0f0f0' }}>
                  <TableCell><h5 style={{ fontWeight: 'bold', margin: 0 }}><Entity entity="mksCylinders" /></h5></TableCell>
                  <TableCell><h5 style={{ fontWeight: 'bold', margin: 0 }}><Entity entity="doorName" /></h5></TableCell>
                  <TableCell><h5 style={{ fontWeight: 'bold', margin: 0 }}><Entity entity="type" /></h5></TableCell>
                  <TableCell><h5 style={{ fontWeight: 'bold', margin: 0 }}><Entity entity="quantity" /></h5></TableCell>
                </TableRow>
              </TableHead>
              <TableBody style={{ backgroundColor: 'white' }}>
                {_.map(cylindersDuplicates, (item, index) => {
                  const cylinder = item.cylinder || {};
                  return (
                    <TableRow key={index}>
                      <TableCell><h5 style={{ margin: 0 }}>{cylinder.externalId || cylinder.id || '---'}</h5></TableCell>
                      <TableCell><h5 style={{ margin: 0 }}>{cylinder.doorName || '---'}</h5></TableCell>
                      <TableCell><h5 style={{ margin: 0 }}>{cylinder.type || '---'}</h5></TableCell>
                      <TableCell><h5 style={{ margin: 0 }}>{item.quantity || '---'}</h5></TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          ) : (
            <div style={{ textAlign: 'center', padding: 20 }}>
              <h5 style={{ color: '#888' }}><Entity entity="noItemsFound" /></h5>
            </div>
          )}
        </FormFlatContainer>
      );
    }

    if (requestType === MKS_REQUEST_TYPES.KEY_EXTENSION) {
      const cylinders = data.cylinders ? JSON.parse(data.cylinders) : [];
      
      return (
        <FormFlatContainer
          title="keyExtensionItems"
          icon={<LockOpenOutlined style={{ fontSize: 22, color: '#3f3f3f' }} />}
          containerStyle={{ marginRight: 15, marginTop: 20 }}
        >
          {!_.isEmpty(cylinders) ? (
            <Table size="small">
              <TableHead>
                <TableRow style={{ backgroundColor: '#f0f0f0' }}>
                  <TableCell><h5 style={{ fontWeight: 'bold', margin: 0 }}><Entity entity="mksCylinders" /></h5></TableCell>
                  <TableCell><h5 style={{ fontWeight: 'bold', margin: 0 }}><Entity entity="doorName" /></h5></TableCell>
                  <TableCell><h5 style={{ fontWeight: 'bold', margin: 0 }}><Entity entity="marking" /></h5></TableCell>
                  <TableCell><h5 style={{ fontWeight: 'bold', margin: 0 }}><Entity entity="type" /></h5></TableCell>
                </TableRow>
              </TableHead>
              <TableBody style={{ backgroundColor: 'white' }}>
                {_.map(cylinders, (cylinder, index) => (
                  <TableRow key={index}>
                    <TableCell><h5 style={{ margin: 0 }}>{cylinder.externalId || cylinder.id || '---'}</h5></TableCell>
                    <TableCell><h5 style={{ margin: 0 }}>{cylinder.doorName || '---'}</h5></TableCell>
                    <TableCell><h5 style={{ margin: 0 }}>{cylinder.marking || '---'}</h5></TableCell>
                    <TableCell><h5 style={{ margin: 0 }}>{cylinder.type || '---'}</h5></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <div style={{ textAlign: 'center', padding: 20 }}>
              <h5 style={{ color: '#888' }}><Entity entity="noItemsFound" /></h5>
            </div>
          )}
        </FormFlatContainer>
      );
    }

    if (requestType === MKS_REQUEST_TYPES.CYLINDER_EXTENSION) {
      const keys = data.keys ? JSON.parse(data.keys) : [];
      
      return (
        <FormFlatContainer
          title="cylinderExtensionItems"
          icon={<KeyOutlinedIconCustom style={{ width: 22, color: '#3f3f3f' }} />}
          containerStyle={{ marginRight: 15, marginTop: 20 }}
        >
          {!_.isEmpty(keys) ? (
            <Table size="small">
              <TableHead>
                <TableRow style={{ backgroundColor: '#f0f0f0' }}>
                  <TableCell><h5 style={{ fontWeight: 'bold', margin: 0 }}><Entity entity="mksKeys" /></h5></TableCell>
                  <TableCell><h5 style={{ fontWeight: 'bold', margin: 0 }}><Entity entity="designation" /></h5></TableCell>
                  <TableCell><h5 style={{ fontWeight: 'bold', margin: 0 }}><Entity entity="keyFunction" /></h5></TableCell>
                </TableRow>
              </TableHead>
              <TableBody style={{ backgroundColor: 'white' }}>
                {_.map(keys, (key, index) => (
                  <TableRow key={index}>
                    <TableCell><h5 style={{ margin: 0 }}>{key.externalId || key.id || '---'}</h5></TableCell>
                    <TableCell><h5 style={{ margin: 0 }}>{key.designation || '---'}</h5></TableCell>
                    <TableCell><h5 style={{ margin: 0 }}>{key.keyFunction || '---'}</h5></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <div style={{ textAlign: 'center', padding: 20 }}>
              <h5 style={{ color: '#888' }}><Entity entity="noItemsFound" /></h5>
            </div>
          )}
        </FormFlatContainer>
      );
    }

    return null;
  }

  render() {
    const { requestData } = this.props;
    
    const statusParams = requestData.status && MKS_REQUEST_STATUSES_PARAMETERS[requestData.status] 
      ? MKS_REQUEST_STATUSES_PARAMETERS[requestData.status] 
      : null;

    return (
      <div style={{ paddingBottom: 100 }}>
        <FormFlatContainer
          title="requestInformation"
          subtitle="requestInformationSubtitle"
          icon={<CommentOutlined style={{ fontSize: 22, color: '#3f3f3f' }} />}
          containerStyle={{ marginRight: 15, marginTop: 0 }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <div style={{ flex: 1 }}>
                <h5 style={{ margin: 0, marginBottom: 5, color: '#888', fontSize: 14 }}>
                  <Entity entity="id" />
                </h5>
                <h4 style={{ margin: 0, fontWeight: 'bold', fontSize: 16 }}>{requestData.id || '---'}</h4>
              </div>
              <div style={{ flex: 1 }}>
                <h5 style={{ margin: 0, marginBottom: 5, color: '#888', fontSize: 14 }}>
                  <Entity entity="status" />
                </h5>
                {statusParams ? (
                  <Chip 
                    label={<Entity entity={statusParams.string} />}
                    style={{ 
                      backgroundColor: statusParams.backgroundColor,
                      color: statusParams.textColor,
                      fontWeight: 'bold',
                      fontSize: 12,
                    }}
                  />
                ) : (
                  <h4 style={{ margin: 0, fontWeight: 'bold', fontSize: 16 }}>{requestData.status || '---'}</h4>
                )}
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <div style={{ flex: 1 }}>
                <h5 style={{ margin: 0, marginBottom: 5, color: '#888', fontSize: 14 }}>
                  <Entity entity="requestType" />
                </h5>
                <h4 style={{ margin: 0, fontWeight: 'bold', fontSize: 16 }}>
                  {requestData.requestType ? <Entity entity={requestData.requestType} /> : '---'}
                </h4>
              </div>
              <div style={{ flex: 1 }}>
                <h5 style={{ margin: 0, marginBottom: 5, color: '#888', fontSize: 14 }}>
                  <Entity entity="createdBy" />
                </h5>
                <h4 style={{ margin: 0, fontWeight: 'bold', fontSize: 16 }}>{requestData.createdBy || '---'}</h4>
              </div>
            </div>
            {requestData.deliveryDate ? (
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <div style={{ flex: 1 }}>
                  <h5 style={{ margin: 0, marginBottom: 5, color: '#888', fontSize: 14 }}>
                    <Entity entity="deliveryDate" />
                  </h5>
                  <h4 style={{ margin: 0, fontWeight: 'bold', fontSize: 16 }}>
                    {moment(requestData.deliveryDate).format('DD MMM YYYY')}
                  </h4>
                </div>
                <div style={{ flex: 1 }} />
              </div>
            ) : null}
          </div>
        </FormFlatContainer>

        {this.renderRequestTypeDetails()}

        {requestData.notes ? (
          <FormFlatContainer
            title="notes"
            containerStyle={{ marginRight: 15, marginTop: 20 }}
          >
            <div style={{ padding: 15, backgroundColor: '#fafafa', borderRadius: 8 }}>
              <h5 style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {requestData.notes}
              </h5>
            </div>
          </FormFlatContainer>
        ) : null}

        {requestData.documents && !_.isEmpty(requestData.documents) ? (
          <FormFlatContainer
            title="attachments"
            containerStyle={{ marginRight: 15, marginTop: 20 }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {_.map(_.keys(requestData.documents), (documentKey, index) => (
                <div 
                  key={index}
                  style={{ 
                    padding: 15,
                    backgroundColor: '#f5f5f5',
                    borderRadius: 8,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                    <FileCheckIconCustom
                      style={{ width: 24, color: BLUE, marginRight: 12 }}
                    />
                    <h5 style={{ margin: 0, fontWeight: 'bold', wordBreak: 'break-all' }}>
                      {documentKey}
                    </h5>
                  </div>
                  <IconButton
                    onClick={() => window.open(requestData.documents[documentKey], '_blank')}
                    style={{ padding: 8, marginLeft: 10 }}
                  >
                    <GetAppIcon style={{ fontSize: 22, color: BLUE }} />
                  </IconButton>
                </div>
              ))}
            </div>
          </FormFlatContainer>
        ) : null}
      </div>
    );
  }
}

export default MksRequestDetailsView;

